export default "__VITE_ASSET__CnnMG5zu__"